import { Clock, LogOut } from "lucide-react";
import { useAuth } from "@/lib/AuthContext";

export default function PendingPage() {
  const { session, signOut, profileError } = useAuth();
  return (
    <div className="grain flex min-h-screen items-center justify-center bg-[#09090b] px-4">
      <div data-testid="pending-activation" className="rise relative z-10 w-full max-w-md space-y-6 rounded-2xl border border-white/5 bg-[#111114] p-8 text-center">
        <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-[var(--gold-soft)] text-[var(--gold)]">
          <Clock className="h-7 w-7" />
        </div>
        <h1 className="font-display text-2xl font-bold">Cuenta pendiente</h1>
        <p data-testid="pending-activation-message" className="text-sm leading-relaxed text-zinc-400">
          Tu cuenta está pendiente de activación. Ponte en contacto con el soporte para habilitar tu suscripción.
        </p>
        <p className="text-xs text-zinc-400">{session?.user?.email}</p>
        {profileError && (
          <p data-testid="pending-profile-error" className="text-xs text-zinc-400">
            No se pudo comprobar tu perfil.{" "}
            <button data-testid="pending-retry-btn" onClick={() => window.location.reload()} className="text-[var(--gold)] underline">Reintentar</button>
          </p>
        )}
        <button data-testid="pending-logout-btn" onClick={signOut}
          className="mx-auto flex items-center gap-2 rounded-lg border border-white/10 px-4 py-2 text-sm text-zinc-300 transition-colors hover:border-[var(--gold)] hover:text-[var(--gold)]">
          <LogOut className="h-4 w-4" /> Cerrar sesión
        </button>
      </div>
    </div>
  );
}
